// extracted by mini-css-extract-plugin
export var dividerContainer = "_8v-0";
export var line = "_8v-1";